var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.6 15.8-3.1-3.1c-.6-.6-1.6-.6-2.3 0l-1.6 1.6c-.1-.1-.2-.1-.3-.2-1-.5-2.3-1.3-3.7-2.7S6.4 8.6 5.9 7.7c-.1-.1-.1-.2-.2-.3l1-1 .5-.5c.6-.6.7-1.7 0-2.3L4.2.4c-.6-.6-1.6-.6-2.3 0l-.8 1c-.3.4-.5.8-.7 1.3q-.3.6-.3 1.2c-.4 3.4 1.1 6.5 5.3 10.7 5.8 5.8 10.5 5.4 10.7 5.3.4-.1.9-.2 1.3-.3.5-.2.9-.4 1.3-.7l.9-.9c.5-.6.6-1.6 0-2.2"
  })));
};
export default SvgPhone;